// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tt-0";